import { defineStore } from 'pinia'

export const useCommonStore = defineStore('common', {
  state: () => {
    return {
      deviceInfo: {}, // 设备信息
      skuInfo: null, // sku信息
      paymentInfo: null,
      globalDatas: {},
    }
  },
  getters: {
    getDeviceInfo: (state) => state.deviceInfo,
    getPaymentInfo: (state) => state.paymentInfo,
    getGlobalDatas: (state) => state.globalDatas,
  },
  actions: {
    setDeviceInfo(val) {
      this.deviceInfo = val
    },
    setPaymentInfo(val) {
      this.paymentInfo = val
    },
    setGlobalDatas(key, val) {
      this.globalDatas[key] = val
    },
  },
})
